import { TranslatedProperty } from '@/core/models/TranslatedProperty';
import { WorkerStatuteKey } from '../worker-statutes/worker-statute.interface';

export interface ActivityRisk {
   id: number;
   key: ActivityRiskKey;
   created_at: Date;
   name: TranslatedProperty;
   updated_at: Date;
}

export enum ActivityRiskKey {
   Nihil = 'nihil',
   ArbZonderVerplaatsing = 'arb-zonder-verplaatsing',
   ArbOpWerf = 'arb-op-werf',
   Huisbewaarders = 'huisbewaarders',
   SchoonmaakOnderhoud = 'schoonmaak-onderhoud',
   Keukenpersoneel = 'keukenpersoneel',
   Chauffeur = 'chauffeur',
   BedZonderVerplaatsing = 'bed-zonder-verplaatsing',
   BedOccBuiten = 'bed-occ-buiten',
   BedBuitenRegelmatig = 'bed-buiten-regelmatig',
   Vertegenwoordiger = 'vertegenwoordiger',
   BedManueel = 'bed-manueel',
   BedThuiwerk = 'bed-thuiwerk',
   VerzorgendPersoneel = 'verzorgend-personeel',
   Verkoper = 'verkoper',
   Voetballer = 'voetballer',
   VoetballerNStatBetGroter = 'voetballer-n-stat-bet-groter',
   VoetballerNStatBetKleiner = 'voetballer-n-stat-bet-kleiner',
   AndereSport = 'andere-sport',
}

export const GROUPED_ACTIVITY_RISKS = [
   {
      statutes: [WorkerStatuteKey.ARB, WorkerStatuteKey.WERKARB, WorkerStatuteKey.JOBARB],
      activityRisks: [
         ActivityRiskKey.Nihil,
         ActivityRiskKey.ArbZonderVerplaatsing,
         ActivityRiskKey.ArbOpWerf,
         ActivityRiskKey.Huisbewaarders,
         ActivityRiskKey.SchoonmaakOnderhoud,
         ActivityRiskKey.Keukenpersoneel,
         ActivityRiskKey.Chauffeur,
      ],
   },
   {
      statutes: [WorkerStatuteKey.BED, WorkerStatuteKey.WERKBED, WorkerStatuteKey.JOBBED],
      activityRisks: [
         ActivityRiskKey.BedZonderVerplaatsing,
         ActivityRiskKey.BedOccBuiten,
         ActivityRiskKey.BedBuitenRegelmatig,
         ActivityRiskKey.Vertegenwoordiger,
         ActivityRiskKey.BedManueel,
         ActivityRiskKey.BedThuiwerk,
         ActivityRiskKey.VerzorgendPersoneel,
         ActivityRiskKey.Voetballer,
         ActivityRiskKey.VoetballerNStatBetGroter,
         ActivityRiskKey.VoetballerNStatBetKleiner,
         ActivityRiskKey.AndereSport,
      ],
   },
];
